import { render, staticRenderFns } from "./productsDetails.vue?vue&type=template&id=4cd1a018&"
import script from "./productsDetails.vue?vue&type=script&lang=js&"
export * from "./productsDetails.vue?vue&type=script&lang=js&"
import style0 from "./productsDetails.vue?vue&type=style&index=0&id=4cd1a018&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd1a018')) {
      api.createRecord('4cd1a018', component.options)
    } else {
      api.reload('4cd1a018', component.options)
    }
    module.hot.accept("./productsDetails.vue?vue&type=template&id=4cd1a018&", function () {
      api.rerender('4cd1a018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/products/productsDetails.vue"
export default component.exports